const Loading = () => {
    return (
        <>
            <div>...please wait</div>
        </>
    );
}

export default Loading